import IconWrapper from '@components/ui/Icons';
import { ReactElement } from 'react';
import styles from '../ProductReviews/ProductReviews.module.scss';

export interface RatingStarsProps {
  rating: number;
}
export const RatingStars = ({ rating = 0 }: RatingStarsProps): ReactElement => {
  const stars = [];

  for (let i = 0; i <= 4; i++) {
    const starsRemaining = rating - i;

    if (starsRemaining >= 1) {
      stars.push(
        <IconWrapper
          icon="review-star-full"
          key={`star-${i}`}
          classNames={styles.reviewsStar}
          testId="review-star-full"
          width={16}
          height={16}
        />
      );
    } else if (starsRemaining <= 0) {
      stars.push(
        <IconWrapper
          icon="review-star-empty"
          key={`star-${i}`}
          classNames={styles.reviewsStar}
          testId="review-star-empty"
          width={16}
          height={16}
        />
      );
    } else {
      const greenStarWidth = starsRemaining * 100;
      stars.push(
        <div
          className={styles.partialReviewStarContainer}
          key={`star-${i}`}
          data-testid="review-star-partial"
        >
          <div
            className={styles.partialGreenReviewStar}
            style={{ width: `${greenStarWidth}%` }}
          >
            <IconWrapper
              icon="review-star-full"
              classNames={styles.reviewsStar}
              width={16}
              height={16}
            />
          </div>
          <IconWrapper
            icon="review-star-empty"
            classNames={styles.reviewsStar}
            width={16}
            height={16}
          />
        </div>
      );
    }
  }
  return <>{stars}</>;
};

export default RatingStars;
